import { takeEvery, put, call } from "redux-saga/effects";

import {
  getPoliciesAPI,
  addPolicyAPI,
  getPolicyAPI,
  updatePolicyAPI,
  deletePolicyAPI,
  getDefaultPolicyAPI,
  sendContactUsMessageAPI,
  sendDeleteAccountRequestAPI,
} from "../../helpers/backend.helper";
import {
  GET_POLICIES,
  ADD_POLICY,
  GET_POLICY,
  UPDATE_POLICY,
  DELETE_POLICY,
  GET_DEFAULT_POLICY,
  SEND_CONTACT_US_MESSAGE,
  SEND_DELETE_ACCOUNT_REQUEST,
} from "./actionTypes";
import {
  addPolicyError,
  addPolicySuccess,
  deletePolicyError,
  deletePolicySuccess,
  getPolicyError,
  getPoliciesError,
  getPoliciesSuccess,
  getPolicySuccess,
  updatePolicyError,
  updatePolicySuccess,
  getDefaultPolicySuccess,
  getDefaultPolicyError,
} from "./actions";

function* getPolicies({ payload: { request } }) {
  try {
    const response = yield call(getPoliciesAPI, request);
    if (response) {
      yield put(getPoliciesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getPoliciesError(error));
  }
}

function* addPolicy({ payload: { request } }) {
  try {
    const response = yield call(addPolicyAPI, request);
    if (response) {
      yield put(addPolicySuccess());
    }
  } catch (error) {
    yield put(addPolicyError(error));
  }
}

function* getPolicy({ payload: { id } }) {
  try {
    const response = yield call(getPolicyAPI, id);
    if (response) {
      yield put(getPolicySuccess(response?.data));
    }
  } catch (error) {
    yield put(getPolicyError(error));
  }
}

function* updatePolicy({ payload: { request } }) {
  try {
    const response = yield call(updatePolicyAPI, request);
    if (response) {
      yield put(updatePolicySuccess());
    }
  } catch (error) {
    yield put(updatePolicyError(error));
  }
}

function* deletePolicy({ payload: { id } }) {
  try {
    const response = yield call(deletePolicyAPI, id);
    if (response) {
      yield put(deletePolicySuccess());
    }
  } catch (error) {
    yield put(deletePolicyError(error));
  }
}

function* getDefaultPolicy() {
  try {
    const response = yield call(getDefaultPolicyAPI);
    if (response) {
      yield put(getDefaultPolicySuccess(response?.data));
    }
  } catch (error) {
    yield put(getDefaultPolicyError(error));
  }
}

function* sendContactUsMessage({ payload: { message } }) {
  yield call(sendContactUsMessageAPI, message);
}

function* sendDeleteAccountRequest({ payload: { request } }) {
  yield call(sendDeleteAccountRequestAPI, request);
}

function* policiesSaga() {
  yield takeEvery(GET_POLICIES, getPolicies);
  yield takeEvery(ADD_POLICY, addPolicy);
  yield takeEvery(GET_POLICY, getPolicy);
  yield takeEvery(UPDATE_POLICY, updatePolicy);
  yield takeEvery(DELETE_POLICY, deletePolicy);
  yield takeEvery(GET_DEFAULT_POLICY, getDefaultPolicy);
  yield takeEvery(SEND_CONTACT_US_MESSAGE, sendContactUsMessage);
  yield takeEvery(SEND_DELETE_ACCOUNT_REQUEST, sendDeleteAccountRequest);
}

export default policiesSaga;
